import { Navigate, useParams } from 'react-router-dom';

/** Redirecciones desde rutas antiguas hacia el listado con query temporal (o solo listado). */
export const ClientRulesRedirectFromCreate = () => {
  const { clientId } = useParams<{ clientId: string }>();
  return <Navigate to={`/clients/${clientId}/rules?sheet=create`} replace />;
};

export const ClientRulesRedirectFromEdit = () => {
  const { clientId, id } = useParams<{ clientId: string; id: string }>();
  return <Navigate to={`/clients/${clientId}/rules?sheet=edit&editRule=${id}`} replace />;
};

export const ClientRulesRedirectFromView = () => {
  const { clientId } = useParams<{ clientId: string }>();
  return <Navigate to={`/clients/${clientId}/rules`} replace />;
};
